import { createAction, props } from '@ngrx/store'
import {Expense, ExpenseReportAPIModel, ListExpenseAPIRequest, PaginatedAPI} from 'src/models/api.model'

const prefix = '[expense]'

export const FETCH_EXPENSES = createAction(`${prefix} FETCH_EXPENSES`, props<{ payload: ListExpenseAPIRequest }>())
export const FETCH_EXPENSES_SUCCESS = createAction(
  `${prefix} FETCH_EXPENSES_success`,
  props<{ expenses: PaginatedAPI<Expense> }>()
)

export const CLEAR_EXPENSES = createAction(`${prefix} CLEAR_EXPENSES`)

export const FETCH_EXPENSE_REPORT_LIST = createAction(
  `${prefix} FETCH_EXPENSE_REPORT_LIST`,
  props<{ payload: ListExpenseAPIRequest }>()
)
export const FETCH_EXPENSE_REPORT_LIST_SUCCESS = createAction(
  `${prefix} FETCH_EXPENSE_REPORT_LIST_success`,
  props<{ expenseReportList: PaginatedAPI<ExpenseReportAPIModel> }>()
)
